// services/staffService.js

import apiClient from '../services/api';

const staffService = {
  // Get all staff members
  getStaff: async () => {
    try {
      const response = await apiClient.get('/staff');
      return response.data;
    } catch (error) {
      console.error('Error fetching staff:', error);
      throw error;
    }
  },

  // Get revenue-generating staff only
  getRevenueStaff: async () => {
    try {
      const response = await apiClient.get('/staff/revenue');
      return response.data;
    } catch (error) {
      console.error('Error fetching revenue staff:', error);
      throw error;
    }
  },

  // Get support staff only
  getSupportStaff: async () => {
    try {
      const response = await apiClient.get('/staff/support');
      return response.data;
    } catch (error) {
      console.error('Error fetching support staff:', error);
      throw error;
    }
  },

  // Create a new staff member
  createStaffMember: async (staffData) => {
    try {
      const response = await apiClient.post('/staff', staffData);
      return response.data;
    } catch (error) {
      console.error('Error creating staff member:', error);
      throw error;
    }
  },

  // Update an existing staff member
  updateStaffMember: async (id, staffData) => {
    try {
      const response = await apiClient.put(`/staff/${id}`, staffData);
      return response.data;
    } catch (error) {
      console.error('Error updating staff member:', error);
      throw error;
    }
  },

  // Update multiple staff members at once
  updateStaff: async (staffArray) => {
    try {
      const response = await apiClient.put('/staff/bulk', staffArray);
      return response.data;
    } catch (error) {
      console.error('Error updating staff:', error);
      throw error;
    }
  },

  // Delete a staff member
  deleteStaffMember: async (id) => {
    try {
      const response = await apiClient.delete(`/staff/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting staff member:', error);
      throw error;
    }
  },

  // Get staff rates
  getStaffRates: async () => {
    try {
      const response = await apiClient.get('/staff/rates');
      return response.data;
    } catch (error) {
      console.error('Error fetching staff rates:', error);
      throw error;
    }
  },

  // Update staff rates
  updateStaffRates: async (ratesData) => {
    try {
      const response = await apiClient.post('/staff/rates', ratesData);
      return response.data;
    } catch (error) {
      console.error('Error updating staff rates:', error);
      throw error;
    }
  },

  // Trigger data migration (one-time operation)
  migrateStaffData: async () => {
    try {
      const response = await apiClient.post('/staff/migrate');
      return response.data;
    } catch (error) {
      console.error('Error migrating staff data:', error);
      throw error;
    }
  }
};

export default staffService;
